import ReactMarkdown from 'react-markdown';
import './ClimateProject.scss';
import { useTranslation } from 'react-i18next';
import Carousel from 'nuka-carousel/lib/carousel';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosSharpIcon from '@mui/icons-material/ArrowBackIosSharp';
import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Project } from './Project';

const ClimateProject = (props: any) => {
    const { t } = useTranslation();
    const [isMobile, setIsMobile] = useState(false);
    const [currentIndex, setCurrentIndex] = React.useState(0);

    const nextSlide = () => {
        setCurrentIndex(currentIndex + 1);
    };

    const previousSlide = () => {
        setCurrentIndex(currentIndex - 1);
    };

    const handleResize = () => {
        if (window.innerWidth <= 768) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    };

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className='climate-container'>
            {props.metadata.ambition && (
                <div className='emission-wrapper'>
                    <div className='wrapper'>
                        <div className='card'>
                            <h1 className='accent-text title'>
                                {props.translation('emission.title')}
                            </h1>
                            {props.metadata.ambition && (
                                <>
                                    <div className='accent-text m-b-0-5 f-bold'>
                                        {props.translation('emission.ambitionLabel')}
                                    </div>
                                    <h3 className='accent-text m-b-1 inlinePad'>
                                        <ReactMarkdown>{props.metadata.ambition}</ReactMarkdown>
                                    </h3>
                                </>
                            )}
                            {props.metadata.actionPlan && (
                                <>
                                    <div className='accent-text m-b-0-5 f-bold'>
                                        {t('emission.measure')}
                                    </div>
                                    <h3 className='accent-text inlinePad'>
                                        <ReactMarkdown>{props.metadata.actionPlan}</ReactMarkdown>
                                    </h3>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <div className='climate-wrapper'>
                <div className='wrapper'>
                    <div className='card'>
                        <div>
                            <h1 className='title'>
                                {props.translation('climate.title')}
                            </h1>
                        </div>
                        <div>{props.translation('climate.description')}</div>

                        {props.projects?.length > 0 && (
                            <>
                                <div>
                                    <Carousel
                                        withoutControls={true}
                                        slideIndex={currentIndex}
                                        dragging={false}
                                        slidesToShow={isMobile ? 1 : 2}
                                        className='xyg'
                                    >
                                        {props.projects?.sort((a: any, b: any) => {
                                            const yearA = typeof a.emissionYear === 'number' && !isNaN(a.emissionYear) ? a.emissionYear : 
                                                         (typeof a.emissionYear === 'string' && a.emissionYear.trim() !== '' && !isNaN(Number(a.emissionYear))) ? Number(a.emissionYear) : null;
                                            const yearB = typeof b.emissionYear === 'number' && !isNaN(b.emissionYear) ? b.emissionYear : 
                                                         (typeof b.emissionYear === 'string' && b.emissionYear.trim() !== '' && !isNaN(Number(b.emissionYear))) ? Number(b.emissionYear) : null;
                                            
                                            if (yearA === null && yearB === null) return 0;
                                            if (yearA === null) return 1;
                                            if (yearB === null) return -1;
                                            return yearB - yearA;
                                        })?.map((item: any, i: number) => {
                                            return (
                                                <div key={i}>
                                                    <Project item={item} translation={props.translation} />
                                                </div>
                                            );
                                        })}
                                    </Carousel>

                                    {((isMobile && props.projects.length > 1) || (!isMobile && props.projects.length > 2)) && (
                                        <div className='carousel-buttons'>
                                            <Button
                                                onClick={previousSlide}
                                                disabled={currentIndex <= 0}
                                                sx={{
                                                    minWidth: '50px',
                                                    padding: '0px',
                                                    '&:hover': {
                                                        backgroundColor: '#ffffff17',
                                                    },
                                                    left: '-25px',
                                                    display: props.projects.length === 1 ? 'none' : 'inline-block'
                                                }}
                                                className='prev-btn'
                                            >
                                                <ArrowBackIosSharpIcon />
                                            </Button>
                                            <div>{currentIndex + 1} of {props.projects.length}</div>
                                            <Button
                                                onClick={nextSlide}
                                                disabled={currentIndex >= props.projects.length - 1}
                                                sx={{
                                                    minWidth: '50px',
                                                    padding: '0px',
                                                    '&:hover': {
                                                        backgroundColor: '#ffffff17',
                                                    },
                                                    right: '-25px',
                                                    display: props.projects.length === 1 ? 'none' : 'inline-block'
                                                }}
                                                className='next-btn'
                                            >
                                                <ArrowForwardIosSharpIcon />
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClimateProject;
